<template>
  <div class="content">
    <span>Ông/bà</span>
    <span class="highlight font-weight__bold"> {{ fromActorFullName }} </span>
    <span>đã</span>
    <span class="highlight-action"> {{ action }} </span>
    <span> về </span>
    <span class="event">"{{ notiTitle }}"</span>
  </div>
</template>

<script>
import constants from "../../constants";

export default {
  name: "notification-item-cv",
  props: ["vbNotificationView"],
  data() {
    return {
      fromActorFullName: null,
      action: null,
      notiTitle: null,
      dataJson: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.dataJson = JSON.parse(this.vbNotificationView.dataJson);
      let action;
      let fromActor = this.dataJson.requester;
      switch (this.vbNotificationView.messageType) {
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.ADDNOTI:
          action = "Thông báo";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        case constants.VB_NOTIFICATION.MESSAGE_TYPE.DELETE_USERNOTI:
          action = "Hủy thông báo";
          fromActor = fromActor || this.dataJson.assigner;
          break;
        default:
          break;
      }
      this.fromActorFullName = fromActor ? fromActor.fullName : "-";
      this.action = action;
      this.notiTitle = this.dataJson.communication.communicationsName;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/header/notification-item-noti.vue